<script setup lang="ts">
import * as Sentry from '@sentry/nuxt'
import { ArrowLeft } from 'lucide-vue-next'

interface NuxtError {
  statusCode: number
  statusMessage: string
  message: string
  stack?: string
}

const props = defineProps<{
  error: NuxtError
}>()

// Отправляем ошибку в Sentry
if (props.error) {
  Sentry.withScope((scope) => {
    scope.setTag('error_boundary', 'nuxt_error_page')
    scope.setTag('status_code', props.error.statusCode)
    scope.setContext('error_details', {
      status_code: props.error.statusCode,
      status_message: props.error.statusMessage,
      message: props.error.message,
      url: window.location?.href,
    })

    // Создаем Error объект для Sentry
    const error = new Error(props.error.message || props.error.statusMessage)
    error.name = `NuxtError${props.error.statusCode}`
    if (props.error.stack) {
      error.stack = props.error.stack
    }

    Sentry.captureException(error)
  })
}

const error = useError()

definePageMeta({
  layout: false,
  ogImage: false,
})

useHead({
  title: error.value?.statusCode === 404 ? '404 - Страница не найдена' : 'Ошибка',
  meta: [
    {
      name: 'robots',
      content: 'noindex',
    },
  ],
})

function handleError() {
  navigateTo('/', { external: true })
}
</script>

<template>
  <div class="min-h-screen flex items-center justify-center">
    <div class="text-center px-4 max-w-md">
      <h1 class="text-5xl font-bold mb-4 text-gray-900">
        {{ error?.statusCode === 404 ? '404' : 'Ошибка' }}
      </h1>
      <p class="text-xl mb-8 text-gray-600">
        {{ error?.statusCode === 404
          ? 'Такой страницы нет'
          : 'Что-то пошло не так' }}
      </p>
      <Button
        class="transition-transform hover:scale-105"
        @click="handleError"
      >
        <span class="flex items-center gap-2">
          <ArrowLeft class="w-5 h-5" />
          Вернуться на главную
        </span>
      </Button>
    </div>
  </div>
</template>
